import { SLOTS_APIS } from "@/api_framework/api_config";
import { IoverBookingHairCutGroomerResponse } from "@/api_framework/api_modals/Bookings";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import { setBookingGroomerList } from "@/app_redux/reducers/slices/auth/slots_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useOverBookingsGroomerListAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const execute = useCallback(
    async (clinic_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .get(`${SLOTS_APIS?.HAIR_CUT_GROOMERS_LIST?.baseURL}/${clinic_id}` ?? "", {
            params: {},
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IoverBookingHairCutGroomerResponse>) => {
            if (res.data.status === true && res.data) {
              dispatch(
                setBookingGroomerList({
                  data: res.data.data,
                }),
              );
            } else {
              dispatch(
                setBookingGroomerList({
                  data: [],
                }),
              );
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              toast("No records found");
            }
            if (e.response.status === 400) {
              toast.error("No Records Found");
            }
            if (e.response.status === 500) {
              toast.error("Internal Server Error. Contact Tech Team.");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
